/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useFormik } from "formik";

// @material-ui/core components
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  FormControlLabel,
  FormGroup,
  FormLabel,
  LinearProgress,
  TextField,
  Typography,
} from "@material-ui/core";

// Karsten
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import AutoCompleteField from "components/_refactor/fields/autocomplete";

export default function FormDefectReasonDialog({
  open,
  formType,
  onClose,
  selectedDefect,
}) {
  const snackbar = useSnackbar();

  const [submitting, setSubmitting] = useState(false);
  const [reasonsList, setReasonsList] = useState([]);
  const [selectedReason, setSelectedReason] = useState(
    selectedDefect?.IdMotivo || null
  );
  const [selectedReasonComplete, setSelectedReasonComplete] = useState();
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    setSearching(true);
    if (reasonsList.length > 0 && selectedReason) {
      const matchingReason = reasonsList.find(
        (reason) => reason.IdMotivo === selectedReason
      );
      if (matchingReason) {
        setSelectedReasonComplete(matchingReason);
      }
    }
    setSearching(false);
  }, [reasonsList, selectedReason]);

  useEffect(() => {
    const fetchReasons = async () => {
      await Api.get("list-reason", "trocasDevolucoes", "", true)
        .then(({ Success, Result }) => {
          if (Success) {
            setReasonsList(Result.ListaMotivos);
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });        })
        .finally(() => setSearching(false));
    };

    fetchReasons();
  }, []);

  const submit = async (values) => {
    const { defect, ativo } = values;
    const updatedDefect = {};

    setSubmitting(true);

    if (formType === "delete") {
      setSubmitting(true);

      const idDefect = selectedDefect?.IdDefeito;

      await Api.delete(
        "delete-defect",
        "trocasDevolucoes",
        { idDefeito: idDefect.toString() },
        true
      )
        .then((res) => {
          if (res.Success) {
            snackbar.showMessage(`Defeito excluído com sucesso!`, {
              severity: "success",
            });
            setSubmitting(false);
            handleClose({ idDefect });
          } else {
            snackbar.showMessage("Ocorreu um erro ao deletar o defeito.", {
              severity: "error",
            });
            setSubmitting(false);
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });
          setSubmitting(false);        });
    }

    if (formType === "edit") {
      return await Api.put(
        "edit-defect",
        "trocasDevolucoes",
        {
          idDefeito: selectedDefect.IdDefeito,
          defeito: defect,
          status: ativo === true ? 1 : 0,
          idMotivo: selectedReason,
        },
        true
      )
        .then((res) => {
          if (res.Success) {
            snackbar.showMessage(`Defeito atualizado com sucesso!`, {
              severity: "success",
            });
            setSubmitting(false);
            handleClose({ ...updatedDefect, ...res.Result });
          } else {
            snackbar.showMessage(
              `Ocorreu um erro ao atualizar o defeito. Verifique os parâmetros informados.`,
              {
                severity: "error",
              }
            );
            setSubmitting(false);
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });
          setSubmitting(false);        });
    }

    if (formType === "create") {
      return await Api.post(
        "create-defect",
        "trocasDevolucoes",
        {
          idMotivo: selectedReason,
          defeito: defect,
        },
        true
      )
        .then((res) => {
          if (res.Success) {
            snackbar.showMessage(`Defeito criado com sucesso!`, {
              severity: "success",
            });
            setSubmitting(false);
            handleClose({ ...updatedDefect, ...res.Result });
          } else {
            snackbar.showMessage(
              `Ocorreu um erro ao criar o defeito. Verifique os parâmetros informados.`,
              {
                severity: "error",
              }
            );
            setSubmitting(false);
          }
        })
        .catch((error) => {
          snackbar.showMessage(error, {
            severity: "error",
          });
          setSubmitting(false);        });
    }

    return;
  };

  useEffect(() => {
    const handleActiveToggle = async () => {
      if (formType === "active" && selectedDefect) {
        const ativo = selectedDefect.Status;

        setSubmitting(true);

        try {
          const res = await Api.put(
            "edit-defect",
            "trocasDevolucoes",
            {
              idDefeito: selectedDefect.IdDefeito,
              defeito: selectedDefect.Defeito,
              idMotivo: selectedReason,
              status: ativo === 0 ? 1 : 0,
            },
            true
          );

          if (res.Success) {
            snackbar.showMessage(
              `Defeito ${selectedDefect.IdDefeito.toString()} foi ${
                ativo === 1 ? "desativado" : "ativado"
              } com sucesso!`,
              {
                severity: "success",
              }
            );
          } else {
            snackbar.showMessage(
              `Ocorreu um erro ao ${
                ativo === 1 ? "desativar" : "ativar"
              } o defeito ${selectedDefect.IdDefeito.toString()}. Verifique os parâmetros informados.`,
              {
                severity: "error",
              }
            );
          }
        } catch (error) {
          snackbar.showMessage(error, {
            severity: "error",
          });        } finally {
          setSubmitting(false);
          handleClose();
        }
      }
    };

    handleActiveToggle();
  }, [formType, selectedDefect]);

  console.log("selectedDefect", selectedDefect);

  const formik = useFormik({
    initialValues: {
      ativo: selectedDefect?.Status === 1 ? true : false,
      defect: selectedDefect?.Defeito,
    },
    onSubmit: submit,
  });

  console.log("initialValues", formik.initialValues);

  const { values, handleChange, handleSubmit, dirty, resetForm } = formik;

  const handleClose = useCallback(
    (updatedDefect) => {
      resetForm();
      onClose(updatedDefect);
    },
    [onClose, resetForm]
  );

  console.log("reasonsList", reasonsList);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        maxWidth={"xl"}
      >
        <PerfectScrollbar>
          <DialogTitle>
            <span>
              <Typography id="alert-dialog-title" variant="h3" component="h3">
                {`${
                  formType === "edit"
                    ? "Editar"
                    : formType === "delete"
                    ? "Excluir"
                    : formType === "active"
                    ? selectedDefect.Status === 1
                      ? "Inativar"
                      : "Ativar"
                    : "Criar"
                } Motivo`}
              </Typography>
            </span>
          </DialogTitle>
          <PerfectScrollbar>
            <DialogContent style={{ padding: "1rem 1.5rem 0" }}>
              {formType === "delete" ? (
                <>
                  <Typography variant="h4" style={{ marginBottom: "1rem" }}>
                    Confirmar exclusão do Defeito?
                  </Typography>
                </>
              ) : formType === "active" ? (
                <>
                  <Typography variant="h4" style={{ marginBottom: "1rem" }}>
                    {`Confirmar ${
                      selectedDefect.Status === 1 ? "inativação" : "ativação"
                    } do Motivo?`}
                  </Typography>
                </>
              ) : (
                <>
                  <Grid item>
                    <AutoCompleteField
                      label="Motivo de Devolução"
                      onChange={(newValue) => {
                        setSelectedReason(newValue.IdMotivo);
                        setSelectedReasonComplete(newValue);
                      }}
                      value={selectedReasonComplete}
                      options={reasonsList}
                      disabled={submitting || searching}
                      optionLabelKey="Motivo"
                      optionIdKey="IdMotivo"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormGroup>
                      <FormLabel>Defeito *</FormLabel>
                      <TextField
                        name="defect"
                        required
                        fullWidth
                        disabled={submitting}
                        value={values.defect}
                        variant="outlined"
                        onChange={handleChange}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .toString()
                            .slice(0, 200);
                        }}
                      />
                    </FormGroup>
                  </Grid>
                  {formType === "edit" && (
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={values.ativo}
                            onChange={handleChange}
                            name="ativo"
                            color="primary"
                            disabled={submitting}
                          />
                        }
                        label={<FormLabel>Ativo</FormLabel>}
                      />
                    </Grid>
                  )}
                </>
              )}
              {submitting && (
                <div style={{ marginTop: "1rem" }}>
                  <span>{`${
                    formType === "create"
                      ? "Criando"
                      : formType === "edit"
                      ? "Atualizando"
                      : formType === "active"
                      ? selectedDefect.Status === 1
                        ? "Inativando"
                        : "Ativando"
                      : "Deletando"
                  } Motivo...`}</span>
                  <LinearProgress />
                </div>
              )}
            </DialogContent>
          </PerfectScrollbar>
          <DialogActions>
            <Button component={Box} onClick={handleClose} disabled={submitting}>
              Cancelar
            </Button>
            {formType === "delete" ? (
              <Button
                color="default"
                variant="contained"
                type="submit"
                disabled={submitting}
                onClick={submit}
              >
                Confirmar
              </Button>
            ) : formType === "active" ? (
              <Button
                color="default"
                variant="contained"
                type="submit"
                disabled={submitting}
                onClick={submit}
              >
                {selectedDefect.Status == 1 ? "Inativar" : "Ativar"}
              </Button>
            ) : (
              <Button
                color="default"
                variant="contained"
                type="submit"
                disabled={
                  submitting ||
                  (formType !== "edit" && !dirty) ||
                  MaskAndValid.isNullOrEmpty(values.defect)
                }
                onClick={handleSubmit}
              >
                {formType === "edit" ? "Atualizar" : "Criar"}
              </Button>
            )}
          </DialogActions>
        </PerfectScrollbar>
      </Dialog>
    </>
  );
}
